import { useEffect } from 'react';
import { useQuery } from 'react-query';

import TagManager from 'react-gtm-module';

import { customizationsApi } from '../../api/customizations';

export const useGTM = () => {
	// Same query key as App.tsx, so react-query serves this from cache
	// instead of issuing a second request.
	const { data } = useQuery(
		[customizationsApi.find.key],
		customizationsApi.find.fetch,
		{
			refetchOnWindowFocus: false
		}
	);

	const id = data?.integrations?.tagManagerId;

	useEffect(() => {
		if (!id) return;

		if (id.startsWith('UA-')) return;

		TagManager.initialize({
			gtmId: id
		});
	}, [id]);
};
